import React from 'react';
import Home from '../components/Home';
import Intro from '../components/Intro';
import Products from '../components/Products';
import Services from '../components/Services';
import Contact from './Contact';


const Main = () => {
    return (
        <>
            <Home />
            <Intro />
            <Services/>
            <Products/>
            <Contact/>
        </>

    )
}

export default Main;

